/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class CustomerAccountListModel extends JSONable {
  uuid: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  serviceProviderName: string | undefined = undefined;
  billingName: string | undefined = undefined;
  billingAccountNumber: string | undefined = undefined;
  accountName: string | undefined = undefined;
  accountNumber: string | undefined = undefined;
  status: string | undefined = undefined;
  accountCreatedAt: Date | undefined = undefined;
  creditStopped: boolean | undefined = undefined;
  billingCycle: string | undefined = undefined;
}
